import { Link } from "react-router-dom";
import { routeTo } from "router";
import { useAppDispatch, useAppSelector } from "store";
import { sandboxActionInvoked } from "store/features";
import { Icon, Text, Tooltip } from "@itwin/itwinui-react";
import styles from "./SandboxTitle.module.css";
import { runtimeEnv } from "configuration";
import { SvgStatusWarning } from "@itwin/itwinui-icons-react";

export const SandboxTitle = () => {
  const dispatch = useAppDispatch();
  const sandbox = useAppSelector((state) => state.activeSandbox.metadata);

  const onClick = () => {
    if (sandbox)
      dispatch(sandboxActionInvoked({ type: "sandbox-settings", args: { userId: sandbox.userId, sandboxId: sandbox.id } }));
  }

  if (!sandbox)
    return null;

  return (
    <div className={styles.block}>
      {sandbox.itwinVersion && runtimeEnv.REACT_APP_PREFERRED_VERSION !== sandbox.itwinVersion &&
        <Tooltip content={`This sandbox uses an older version of iTwin.js (${sandbox.itwinVersion})`} delay={500}>
          <Icon fill="warning" size="medium" className={styles.warningIcon} data-testid="atp-version-warning">
            <SvgStatusWarning />
          </Icon>
        </Tooltip>
      }
      <Text variant="subheading" className={styles.title} onClick={onClick} data-testid="atp-sandbox-name">{sandbox.name}</Text>
      <Text variant="body">
        <Text isMuted as="span">&nbsp;by&nbsp;</Text>
        <Link to={routeTo.search(sandbox.username)} className="iui-anchor" data-testid="atp-author-name">{sandbox.username}</Link>
      </Text>
    </div>
  );
}